module.exports = "<corporate-invoice-item-page></corporate-invoice-item-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appCustomers/corporateInvoiceItem.html
// module id = 1972
// module chunks = 0